import { render, staticRenderFns } from "./gl-entity-icon.vue?vue&type=template&id=4c40f888&scoped=true"
import script from "./gl-entity-icon.vue?vue&type=script&lang=js"
export * from "./gl-entity-icon.vue?vue&type=script&lang=js"
import style0 from "./gl-entity-icon.vue?vue&type=style&index=0&id=4c40f888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40f888",
  null
  
)

export default component.exports